module.exports = __webpack_public_path__ + "21a81555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_appledaily@2x.png
// module id = 1185
// module chunks = 0